// SCRIPT GUIDE DES TAILLES
// 2021 Février - UpWork Chander Shekhar

const brandPhoneSelect = document.getElementById('mm-marque-select');

function forgetUserChoicePhone() {
  // Set item
  localStorage.removeItem("Phone_brand");
  localStorage.removeItem("Phone_model");
  localStorage.removeItem("Phone_brand_model");
  localStorage.removeItem("Phone_size");

  location.reload();
}

function mmUpdateCTASize(brand, model, size) {
  // Set item
  localStorage.setItem("Phone_brand", `${brand}`);
  localStorage.setItem("Phone_model", `${model}`);
  localStorage.setItem("Phone_size", `${size}`);
  localStorage.setItem("Phone_brand_model", `${brand} - ${model}`);

  var buttons = document.querySelectorAll('#product-form .mm-size-modal-button');

  if(buttons) {
    buttons.forEach(function(button){
      button.outerHTML = `
        <span class="mm-size-modal-button mm-moto-cta-compatible">
          <p onclick="mmOpenSizeModal()">${brand} - ${model}</p>
          <svg onclick="forgetUserChoicePhone()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      `;
    })
  }
}

function getPhoneModel() {
  if(localStorage.getItem("Phone_brand_model")){
    var phone_model = localStorage.getItem("Phone_brand_model");

    var buttons = document.querySelectorAll('.mm-size-modal-button');

    if(buttons) {
      buttons.forEach(function(button) {
        button.outerHTML = `
          <span class="mm-size-modal-button mm-moto-cta-compatible">
            <p onclick="mmOpenSizeModal()">${phone_model}</p>
            <svg onclick="forgetUserChoicePhone()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;        
      })
    }

    // Now we populate the modal
    document.getElementById('mm-marque-select').value = localStorage.getItem("Phone_brand");
    var event = new Event('change');
    document.getElementById('mm-marque-select').dispatchEvent(event);

    document.getElementById('mm-size-model').style.display = 'flex';
    document.getElementById('mm-model-select').value = localStorage.getItem("Phone_size");
    var event = new Event('click');
    document.getElementById('mmModalSizeSubmit').dispatchEvent(event);
  }
}

// Setup button onload
document.addEventListener("DOMContentLoaded", (event) => {
  getPhoneModel();
});
